<template>
  <section class="footer-container">
    <p class="footer-infor-txt">
      Copyright © 2008-现在 vip.com，All Rights Reserved&nbsp;&nbsp;使用本网站即表示接受
      <a rel="nofollow" target="_blank" href="//h5rsc.vip.com/h5rscSupportClause/h5rscSupportClause/index.html">唯品会用户协议</a>。版权所有
      <a rel="nofollow" target="_blank" href="//www.vip.com/">广州唯品会电子商务有限公司</a>
      <br>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010302111111">
          <img src="//a.vpimg4.com/upload/actpics/act/sp/police_icon.png" width="14" height="14" style="margin:2px 3px 0 0;">粤公网安备 44010302111111号
      </a>&nbsp;&nbsp;
      <a rel="nofollow" target="_blank" href="https://beian.miit.gov.cn/">粤ICP备08114786号</a>&nbsp;&nbsp;
      <a rel="nofollow" target="_blank" href="//h5rsc.vip.com/h5rscActValueAddedSe/h5rscActValueAddedSe/index.html">增值业务经营许可证：粤B2-20170777 </a>
      <a rel="nofollow" target="_blank" href="https://a.vpimg2.com/upload/merchandise/pdcvis/2021/09/26/21/202109261150384052189.jpg">网络文化经营许可证：粤网文〔2021〕2056-282号</a>
      <br>
      <a rel="nofollow" target="_blank" href="//h5rsc.vip.com/h5rscActBusinessLice/h5rscActBusinessLice/index.html">经营主体证照</a>&nbsp;&nbsp;
      <a target="_blank" href="//help.vip.com/themelist.php?type=detail&amp;id=475" rel="nofollow">风险监测信息</a>&nbsp;&nbsp;
      <a rel="nofollow" target="_blank" href="//h5rsc.vip.com/h5rscActDrugInfoLice/h5rscActDrugInfoLice/index.html">互联网药品信息服务资格证书：（粤）-经营性-2018-0271</a>
      <a rel="nofollow" target="_blank" href="//h5rsc.vip.com/h5rscActFoodTradeLic/h5rscActFoodTradeLic/index.html"> 网络食品交易第三方平台备案凭证：粤B2-20170777 </a>
      <a rel="nofollow" target="_blank" href="//h5rsc.vip.com/h5rscActInstrumentTr/h5rscActInstrumentTr/index.html">医疗器械网络交易服务第三方平台备案
      <br>
      凭证：（粤）网械平台备字[2019]第00001号</a>&nbsp;&nbsp;
      <span style="color:#808080">出版物网络交易平台服务经营备案证：粤新出网备（2021）1号</span>
      <span>&nbsp;<a target="_blank" href="http://www.gdjubao.cn/jb/?harm_type=18">未成年人关怀专区</a></span><br>
      <span style="color:#808080">违法和不良信息举报电话：4006789888&nbsp;算法推荐违规举报电话：4006789888</span><span>&nbsp;<a target="_blank" href="https://a.vpimg2.com/upload/merchandise/pdcvis/2022/09/30/109/202209301420030668062.jpg">广东省放心消费承诺单位</a></span>
    </p>
    <p class="footer-pic">
      <a rel="nofollow" target="_blank" href="//weiquan.vip.com">
        <i class="footer-pic-ico04" title="消费维权服务站"></i>
      </a>
      <a rel="nofollow" target="_blank" href="https://www.12377.cn/">
        <i class="footer-pic-ico11" title="不良信息举报中心"></i>
      </a>
      <a rel="nofollow" target="_blank" href="https://xyt.xinchacha.com/pcinfo?sn=1438061342068367360&amp;certType=4" id="_xinchacharenzheng_cert_vip_chengxincn">
        <img src="//a.vpimg2.com/upload/merchandise/pdcvis/2022/10/21/177/202210211645205194200.png" style="width:75px; margin-right:5px;">
      </a>
      <a rel="nofollow" target="_blank" href="https://ss.knet.cn/verifyseal.dll?sn=2011022400100006603&amp;ct=df&amp;a=1&amp;pa=0.5265976136604793">
        <i class="footer-pic-ico10" title="可信网站"></i>
      </a>
    </p>
  </section>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.footer-container {
  font: 12px/1.5 tahoma,arial,Hiragino Sans GB,WenQuanYi Micro Hei,\5FAE\8F6F\96C5\9ED1,\5B8B\4F53,sans-serif;
  font-size: 12px;
  color: #999999;
  text-align: center;
  font-weight: 400;
  padding: 0px 0 20px;
  .footer-infor-txt {
    color: #999;
    margin: 14px 0;
    line-height: 20px;
  }
  a {
    color: grey;
  }
  a:hover {
    color:#f10180;
  }
}
.footer-pic {
  img {
    vertical-align: super;
  }
}
.footer-pic-ico01, .footer-pic-ico02, .footer-pic-ico03, .footer-pic-ico04, .footer-pic-ico05, .footer-pic-ico06, .footer-pic-ico07, .footer-pic-ico08, .footer-pic-ico09, .footer-pic-ico10 {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  margin-right: 9px;
  height: 40px;
  background-image: url(//shop.vipstatic.com/img/common/footer-hash-3de6f1ae.png?939748fb);
  background-repeat: no-repeat;
}
.footer-pic-ico04 {
  width: 99px;
  background-position: 0 -150px;
}
.footer-pic-ico11 {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  margin-right: 9px;
  height: 40px;
  background-image: url(//shop.vipstatic.com/img/common/footer_no_good-hash-1fe63524.png?64f2e6d6);
  background-repeat: no-repeat;
  width: 76px;
}
.footer-pic-ico10 {
  width: 76px;
  background-position: 0 -450px;
}
</style>
